import styled from 'styled-components';

// 스타일 컴포넌트
export const TableContainer = styled.div`
  overflow-x: auto;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 14px;
  position: relative;
  z-index: 1;
`;

export const Th = styled.th`
  padding: 12px 8px;
  text-align: left;
  background-color: #f5f5f5;
  border-bottom: 1px solid #ddd;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background-color: #eaeaea;
  }
`;

export const Tr = styled.tr`
  &:hover {
    background-color: #f5f5f5;
    cursor: pointer;
  }
`;

export const Td = styled.td`
  padding: 12px 8px;
  border-bottom: 1px solid #eee;
  white-space: nowrap;
`;

export const EditButton = styled.button`
  padding: 6px 12px;
  background-color: #4285f4;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: #3367d6;
  }
`;

export const FilterHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
`;

export const FilterContainer = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding-bottom: 5px;
  width: 100%;
`;

export const PaginationContainer = styled.div`
  margin-top: 20px;
  position: fixed;
  bottom: 0;
  z-index: 10;
  margin: auto;
  background: rgba(255, 255, 255, 1);
  backdrop-filter: blur(10px);
  left: 0;
  right: 0;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const PageTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: var(--point-color);
  margin-right: 20px;
  white-space: nowrap;
`;
